/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFTNEW_HERO_ABOUT_1339 from '../../sections/SSoftNew_Hero_About_1339/SSoftNew_Hero_About';
import SSOFT_ABOUT_US_967 from '../../sections/SSoft_About_Us_967/SSoft_About_Us';
import SSOFT_OUR_PARTNERS_925 from '../../sections/SSoft_Our_Partners_925/SSoft_Our_Partners';
import SSOFT_SIMPLE_BG_1340 from '../../sections/SSoft_Simple_BG_1340/SSoft_Simple_BG';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'hero' : 'hero'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'about-us' : 'about-us'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'our-partners' : 'our-partners'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'cta-services' : 'cta-services'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> About | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> About | Supersoft</title>;
                   break;
               default:
                   title = <title> About | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Transforming the digital landscape of businesses and unlock infinite opportunities - PT Supersoft' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Mengubah lanskap digital bisnis dan membuka peluang tanpa batas - PT Supersoft' />;
                   break;
               default:
                   description = <meta name='description' content='Transforming the digital landscape of businesses and unlock infinite opportunities - PT Supersoft' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFTNEW_HERO_ABOUT_1339 />
            </div>
            <div ref={this.section2}>
                <SSOFT_ABOUT_US_967 />
            </div>
            <div ref={this.section3}>
                <SSOFT_OUR_PARTNERS_925 />
            </div>
            <div ref={this.section4}>
                <SSOFT_SIMPLE_BG_1340 />
            </div>
           </>
       );
   }
}
export default withParams(project1);